import { MutationTree } from 'vuex'
import { CustomFieldDividerState } from './custom-field-dividers.types'
import { CustomFieldDivider } from '../../types'

export enum MutationTypes {
  SET_ALL_CUSTOM_FIELD_DIVIDERS = 'SET_ALL_CUSTOM_FIELD_DIVIDERS',
  SET_CUSTOM_FIELD_DIVIDERS_LOADING_ERROR = 'SET_CUSTOM_FIELD_DIVIDERS_LOADING_ERROR'
}

export const mutations: MutationTree<CustomFieldDividerState> = {
  [MutationTypes.SET_ALL_CUSTOM_FIELD_DIVIDERS](state, dividers) {
    const dividersObj: Record<'Products' | 'Components' | 'Variants', Array<CustomFieldDivider>> = {
      Products: [],
      Components: [],
      Variants: []
    }
    dividers.forEach((divider: CustomFieldDivider) => {
      dividersObj[divider.location].push(divider)
    })
    state.customFieldDividers = dividersObj
  },
  [MutationTypes.SET_CUSTOM_FIELD_DIVIDERS_LOADING_ERROR](state, error) {
    state.dividersLoadingError = error
  }
}
